/* Tipo di macchina selezionato
null | {"value": machine_type, ...}
*/
import { createContext } from "react";
const SelectedTypeContext = createContext({
    selectedType: null,
    setSelectedType: (type) => {}
  });
export default SelectedTypeContext;